module.exports = __webpack_public_path__ + "static/media/Tooltip.8d00ae37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Tooltip.png
// module id = 1437
// module chunks = 0